<script lang="ts">

  import { Button } from "$lib/components/ui/button"
  import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "$lib/components/ui/sheet"
  import { useDialog } from "$lib/hooks/use-dialog.svelte"
  import XIcon from "@lucide/svelte/icons/x"

  const dialog = useDialog()
  let url = $state("")

  $effect(() => {

    function handleView(event: CustomEvent) {
      url = event.detail as string
      dialog.setOpen(true)
    }

    window.addEventListener("view-help", handleView as EventListener)
    return () => {
      window.removeEventListener("view-help", handleView as EventListener)
    }
  })

</script>
<Sheet
  open={dialog.state}
  onOpenChange={dialog.setOpen}
  onOpenChangeComplete={() => ""}>
  <SheetContent
    class="w-full! p-0 border-none sm:max-w-xl"
    side="right"
    showCloseButton={false}>
    <SheetHeader class="hidden">
      <SheetTitle>Bantuan</SheetTitle>
      <SheetDescription></SheetDescription>
    </SheetHeader>
    <div class="flex h-full flex-col">
      <nav class="sticky w-full top-0 border-b bg-background">
        <div class="flex h-12 items-center justify-between px-3">
          <div class="flex items-center gap-2">
            <Button variant="ghost"
                    size="icon"
                    class="rounded-full"
                    onclick={() => dialog.setOpen(false)}>
              <XIcon/>
            </Button>
            <h1 class="text-lg font-medium">
              Bantuan
            </h1>
          </div>
          <div>
          </div>
        </div>
      </nav>
      <iframe
        src={`/plugins/pdf/web/viewer.html?file=${encodeURIComponent(url)}`}
        class="flex-1 border-none"
        title="Bantuan"></iframe>
    </div>
  </SheetContent>
</Sheet>
